<template>
  <div id="service"></div>
</template>

<script>
export default {
  name: "Service",
};
</script>

<style scoped></style>
